import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { BenchmarkInsightCompetitorsCompset } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

interface ProposedCompsetsResponse {
  compset_proposals: BenchmarkInsightCompetitorsCompset[];
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class ProposedCompsetSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    compset: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: ProposedCompsetsResponse,
    id: string | number,
    requestType: string,
  ) {
    const normalizedPayload = {
      'benchmark-insight/competitors/proposed-compset':
        payload.compset_proposals,
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      normalizedPayload,
      id,
      requestType,
    );
  }
}
